'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Snackbar = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('@material-ui/styles');

var _core = require('@material-ui/core');

var _InfoOutlined = require('@material-ui/icons/InfoOutlined');

var _InfoOutlined2 = _interopRequireDefault(_InfoOutlined);

var _snackbar = require('../../schema/component/snackbar.json');

var _index = require('../../index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-extraneous-dependencies */


var useStyles = (0, _styles.makeStyles)(function () {
  return {
    component: {
      margin: '0 auto',
      width: '340px',
      '& .MuiSnackbarContent-root': {
        display: function display(_ref) {
          var rootDisplay = _ref.rootDisplay;
          return rootDisplay;
        },
        flexWrap: 'nowrap',
        minWidth: '312px',
        padding: '12px 16px'
      },
      '& .MuiSnackbarContent-message': {
        padding: '0px'
      },
      '& .snackbar--withicon': {
        alignItems: 'center'
      },
      '& .snackbar--icon': {
        marginRight: '8px'
      },
      '& .snackbar--action': {
        height: '20px',
        padding: '8px !important'
      },
      '& .snackbar--action-bottom': {
        display: 'flex',
        justifyContent: 'flex-end',
        paddingRight: '28px',
        width: '100%'
      }
    }
  };
});

var Snackbar = function Snackbar(_ref2) {
  var action = _ref2.action,
      anchorOrigin = _ref2.anchorOrigin,
      autoHideDuration = _ref2.autoHideDuration,
      message = _ref2.message,
      messageVariant = _ref2.messageVariant,
      open = _ref2.open,
      Icon = _ref2.Icon,
      onClose = _ref2.onClose,
      variant = _ref2.variant,
      props = _objectWithoutProperties(_ref2, ['action', 'anchorOrigin', 'autoHideDuration', 'message', 'messageVariant', 'open', 'Icon', 'onClose', 'variant']);

  var variantDefault = _snackbar.properties.default.properties;
  var variantSelected = _snackbar.properties[variant] && _snackbar.properties[variant].properties;
  var variantValidation = variantSelected || variantDefault;

  var styles = useStyles({
    rootDisplay: variantValidation.rootDisplay
  });

  return _react2.default.createElement(_core.Snackbar, _extends({
    className: 'snackbar ' + styles.component,
    anchorOrigin: anchorOrigin,
    open: open,
    autoHideDuration: autoHideDuration,
    onClose: onClose,
    message: _react2.default.createElement(
      _index.Typography,
      {
        className: variantValidation.isIcon && 'snackbar--withicon',
        variant: messageVariant,
        'data-color': 'onprimary-high-emphasis',
        'data-display': variantValidation.messageDisplay,
        'data-margin-bottom': variantValidation.messageMarginBottom,
        'data-width': variantValidation.messageWidth
      },
      variantValidation.isIcon && _react2.default.createElement(Icon, { className: 'snackbar--icon' }),
      _react2.default.createElement(
        'span',
        null,
        message
      )
    ),
    action: variantValidation.isAction && action && _react2.default.createElement(
      'div',
      { className: variantValidation.actionClass },
      _react2.default.createElement(
        _index.Button,
        {
          onClick: action.onClick,
          className: 'snackbar--action',
          type: 'text-primary',
          'data-margin-bottom': variantValidation.actionMarginBottom
        },
        action.text
      )
    ),
    rootDisplay: variantValidation.rootDisplay,
    widthAction: action && action.width
  }, props));
};

exports.Snackbar = Snackbar;
Snackbar.defaultProps = {
  action: {
    onClick: function onClick() {},
    text: 'Action',
    width: '65px'
  },
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'center'
  },
  autoHideDuration: 5000,
  Icon: _InfoOutlined2.default,
  message: 'Lorem ipsum dolor sit amet consec',
  messageVariant: 'textbody2-reguler',
  onClose: function onClose() {},
  open: false,
  variant: 'default'
};

Snackbar.propTypes = {
  action: _propTypes2.default.shape({
    onClick: _propTypes2.default.func,
    text: _propTypes2.default.string,
    width: _propTypes2.default.string
  }),
  anchorOrigin: _propTypes2.default.shape({
    vertical: _propTypes2.default.string,
    horizontal: _propTypes2.default.string
  }),
  autoHideDuration: _propTypes2.default.number,
  Icon: _propTypes2.default.node,
  message: _propTypes2.default.string,
  messageVariant: _propTypes2.default.string,
  onClose: _propTypes2.default.func,
  open: _propTypes2.default.bool,
  variant: _propTypes2.default.string
};

exports.default = Snackbar;